import { AppSettings } from '../app-settings';
import { SelectListItemModel } from './select-list-item.model';
import { HttpClient } from '@angular/common/http';
import { SummerAppFieldTypesEnum } from '../enums/field-types.enum';
import { QuestionBaseModel } from "./question-base.model";

export class DropdownQuestionModel extends QuestionBaseModel<string> {

    fieldTypeName = SummerAppFieldTypesEnum.Dropdown;
    options: SelectListItemModel[] = [];
    lookupName:string;

    constructor(options: {} = {}) {
      super(options);
      this.lookupName=options['lookupName'];
    }

    getLookupOptions(http:HttpClient){
      http.post<SelectListItemModel[]>(AppSettings.endpoints.enrollees.dropdwonLookupValues,this.onlineEnrollmentConfigurationId).subscribe((data)=>{
        this.options=data;
      });
    }

  }


// WEBPACK FOOTER //
// ./src/app/shared/models/dropdown-question.model.ts